import type { CompSubscriptionResponse } from "@/hooks/useTeamSubscription"

/**
 * The toast for a Comp Plan result. The comp itself succeeded in every case
 * here; what varies is the creator's pending card-free trial. When Stripe
 * refused to cancel it, our billing row is already marked cancelled and nothing
 * retries, so the admin is the only one left who can finish in Stripe — that
 * case is a destructive toast that names the subscription, not a green one.
 */
export function compPlanToast(result: CompSubscriptionResponse): {
  title: string
  description: string
  variant?: "destructive"
} {
  const created = `Created ${result.stripeSubscriptionId} in Stripe at 100% off.`
  const trial = result.trialCancellation
  if (trial.kind !== "cancelled") {
    return { title: "Plan comped", description: created }
  }
  if (trial.stripeCancelled) {
    return {
      title: "Plan comped",
      description: `${created} Also cancelled the coach's pending trial.`,
    }
  }
  // "Did not confirm", not "refused": a timed-out cancel may well have gone
  // through on Stripe's side. Either way our record already says cancelled and
  // nothing retries, so the admin has to look.
  return {
    title: "Plan comped, but the coach's trial may still be live in Stripe",
    description: `${created} Stripe did not confirm cancelling trial ${
      trial.stripeSubscriptionId ?? "(no Stripe id)"
    }; our record already says cancelled, so check it in the Stripe dashboard and cancel it by hand if it is still live.`,
    variant: "destructive",
  }
}
